import { isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { APPS_LINK } from 'src/app/constants/device_platform';
import { OsDetectorService } from 'src/app/services/os-detector.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'download-mobile-app',
  templateUrl: './download-mobile-app.component.html',
  styleUrls: ['./download-mobile-app.component.scss']
})
export class DownloadMobileAppComponent implements OnInit {
  private os:string='';
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private analytics: AngularFireAnalytics,
    private osDetectorService:OsDetectorService) { }

  ngOnInit(): void {
  }

  openAppLink() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    const {deviceOS} = this.osDetectorService.getDeviceOS();
    if(deviceOS == 'android'){
      window.location.href = APPS_LINK.android;
      this.analytics.logEvent('DOWNLOAD_CLICK', {
        category: 'Download_App',
        action: 'clicked',
        label: 'Android download',
      });
    }else if(deviceOS == 'ios'){
      window.location.href = APPS_LINK.ios;
      this.analytics.logEvent('DOWNLOAD_CLICK', {
        category: 'Download_App',
        action: 'clicked',
        label: 'IOS download',
      });
    }
  }

}
